"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VideoTile;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
var _image = require("@site/pattern-library-core/image");
const VideoTileContainer = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "VideoTileContainer",
  class: "pl-v39oa4r"
});
const Thumbnail = /*#__PURE__*/(0, _react2.styled)(_image.LazyBackgroundImage)({
  name: "Thumbnail",
  class: "pl-t15g1ble"
});
const ContentContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ContentContainer",
  class: "pl-cepjohm"
});
const TextContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TextContainer",
  class: "pl-t1r0zrkt"
});
const VideoTag = /*#__PURE__*/(0, _react2.styled)(_tag.default)({
  name: "VideoTag",
  class: "pl-v1xhfq9c"
});
const Title = /*#__PURE__*/(0, _react2.styled)("p")({
  name: "Title",
  class: "pl-t1dlv664"
});
const VideoIcon = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "VideoIcon",
  class: "pl-vzc3ozm"
});

/**
 * Video Tile component.
 * @module VideoTile
 *
 * @param {Object} props React props
 * @param {String} props._name Name prop
 * @param {String} props.videoTag Video tag displayed below the thumbnail
 * @param {String} props.title Title of the video
 * @param {String} props.url Url of the video
 * @param {String} props.thumbnailUrl Thumbnail url of the video
 * @returns {React.ReactElement} Video Tile component
 * @public
 */
function VideoTile({
  rank,
  videoTag,
  title,
  url,
  thumbnailUrl,
  trackingCustomProperties
}) {
  return /*#__PURE__*/_react.default.createElement(VideoTileContainer, (0, _extends2.default)({
    href: url,
    "data-cy": "video-tile"
  }, _patternLibraryUtils.tracking.create(`video_tile_${rank}_${(0, _patternLibraryUtils.applySnakeCase)(title)}`, true, false, trackingCustomProperties)), /*#__PURE__*/_react.default.createElement(Thumbnail, {
    portrait: thumbnailUrl,
    tablet: thumbnailUrl,
    landscape: thumbnailUrl
  }), /*#__PURE__*/_react.default.createElement(ContentContainer, null, /*#__PURE__*/_react.default.createElement(TextContainer, null, /*#__PURE__*/_react.default.createElement(VideoTag, {
    text: videoTag,
    design: "neutral"
  }), /*#__PURE__*/_react.default.createElement(Title, null, " ", title, " ")), /*#__PURE__*/_react.default.createElement(VideoIcon, {
    "data-cy": "video-icon"
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "video"
  }))));
}
VideoTile.propTypes = {
  rank: _propTypes.default.number,
  videoTag: _propTypes.default.string,
  title: _propTypes.default.string,
  url: _propTypes.default.string,
  thumbnailUrl: _propTypes.default.string,
  trackingCustomProperties: _propTypes.default.object
};